import { createApp } from 'vue'
import App from './App.vue'

// 忽略 ResizeObserver loop 相关报错
const debounce = (fn, delay) => {
  let timer = null
  return function () {
    const context = this
    const args = arguments
    clearTimeout(timer)
    timer = setTimeout(function () {
      fn.apply(context, args)
    }, delay)
  }
}
const _ResizeObserver = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16)
    super(callback)
  }
}

// 捕获并阻止 ResizeObserver 错误冒泡
// const resizeObserverLoopErr = 'ResizeObserver loop completed with undelivered notifications.'
window.addEventListener('error', (event) => {
  if (event.message.includes('ResizeObserver')) {
    event.stopImmediatePropagation()
    event.preventDefault()
  }
})

import i18n from './locale/index'
// import Antd from 'ant-design-vue' // 按需引入，无需全局注册
import { message } from 'ant-design-vue'
import routers from './router/index'
import store from './store/index'
import { _home } from './api'
// import * as Icons from '@ant-design/icons-vue' // 按需引入，无需全局注册
import 'ant-design-vue/dist/antd.variable.min.css'

const app = createApp(App)

// 自动按需引入图标，无需手动注册
// for (const i in Icons) {
//   app.component(i, Icons[i])
// }

// 加载前端静态配置文件
async function getConfig() {
  const res = await _home.getConfig()
  if (res && res.version) store.commit('setFrontVersion', res.version)
}

message.config({
  top: '78px',
  duration: 5
})

app
  // .use(Antd)
  .use(i18n)
  .use(routers)
  .use(store)
  .mount('#app')

getConfig()
